const checkConsecutiveUsernameChars = (password, username) => {
  const normalizedPassword = password.toLowerCase();
  const normalizedUsername = username.toLowerCase();
  for (let index = 0; index <= normalizedUsername.length - 4; index += 1) {
    if (normalizedPassword.includes(normalizedUsername.slice(index, index + 4))) {
      return "Password must not contain 4 consecutive characters from the username.";
    }
  }

  return null;
};

export const validatePassword = (password, username) => {
  const minLength = 8;
  const specialCharacters = /[!£$%^&?*@]/;
  const hasNumber = /\d/;
  const hasUppercase = /[A-Z]/;
  const hasLowercase = /[a-z]/;
  const forbiddenPatterns = ["123", "admin", "password", "qwerty"];

  if (password.length < minLength) {
    return "Password must be at least 8 characters long.";
  }

  if (password.length > 20) {
    return "Password must not exceed 20 characters.";
  }

  if (!specialCharacters.test(password)) {
    return "Password must contain at least one special character (e.g., !, £, $, %).";
  }

  if (!hasNumber.test(password)) {
    return "Password must contain at least one number.";
  }

  if (!hasUppercase.test(password) || !hasLowercase.test(password)) {
    return "Password must contain both uppercase and lowercase letters.";
  }

  if (forbiddenPatterns.some((pattern) => password.toLowerCase().includes(pattern))) {
    return `Password must not contain common patterns like ${forbiddenPatterns.join(
      ", ",
    )}.`;
  }

  if (username) {
    const consecutiveError = checkConsecutiveUsernameChars(password, username);

    if (consecutiveError) {
      return consecutiveError;
    }

  }

  return null;
};

export const getPasswordRuleStates = (password, username) => {
  const value = password || "";
  const userValue = username || "";
  const specialCharacters = /[!£$%^&?*@]/;
  const hasNumber = /\d/;
  const hasUppercase = /[A-Z]/;
  const hasLowercase = /[a-z]/;
  const forbiddenPatterns = ["123", "admin", "password", "qwerty"];

  return [
    {
      key: "length",
      label: "At least 8 characters",
      passed: value.length >= 8,
    },
    {
      key: "case",
      label: "At least 1 uppercase and 1 lowercase letter",
      passed: hasUppercase.test(value) && hasLowercase.test(value),
    },
    {
      key: "number",
      label: "At least 1 number",
      passed: hasNumber.test(value),
    },
    {
      key: "special",
      label: "At least 1 special character",
      passed: specialCharacters.test(value),
    },
    {
      key: "patterns",
      label: "No common patterns like 123, admin, password, qwerty",
      passed: !forbiddenPatterns.some((pattern) =>
        value.toLowerCase().includes(pattern),
      ),
    },
    {
      key: "username",
      label: "Must not use too much of the username",
      passed:
        !userValue ||
        !checkConsecutiveUsernameChars(value, userValue),
    },
  ];
};
